export const OnboardingRoutes = {
  AccreditedInvestor: '/onboarding/accredited-investor',
  AddEntityContactInfo: '/onboarding/add-entity-contact-info',
  AddEntityDetails: '/onboarding/add-entity-details',
  ClaimVerifyIdentity: '/onboarding/claim-verify-identity',
  CreateAccount: '/onboarding/create-account',
  GetStarted: '/onboarding/get-started',
  Onboarding: '/onboarding',
  SelectEntityType: '/onboarding/select-entity-type',
  VerifyEmail: '/onboarding/verify-email',
  VerifyIdentity: '/onboarding/verify-identity',
  VerifyInformation: '/onboarding/verify-information',
  WelcomeComplete: '/onboarding/complete',
};
